import Constants from '@/Constants';
import { BotRecommendationRequest } from '@/models/BotRecommendationRequest';
import Item, { DynamicAttribute } from '@/models/Item';
import { buildingContentRecommendations, sendNewEventRequest } from '@/store/bot/actions';
import { LearningMap } from '@/store/learningMap/types';
import { Dispatch } from 'redux';
import _ from 'underscore';
import { analyticsService, FlowEvents } from './AnalyticsService';
import { getPercentage } from './UtilService';

export default class {
    static recommendContent(dispatch: Dispatch, currentContent: Item, currentLearningMap: LearningMap) {
        const content = currentContent as Item;

        const categoryIds: string = _.pluck(content.categories || [], 'id').join(',');
        let contentTypes: string =
            content.mediaType === Constants.contentMediaType.EXTERNAL ? (content.dynamicAttributes as DynamicAttribute).type : content.mediaType;
        const availableTypes: string[] = [Constants.contentMediaType.AUDIO, Constants.contentMediaType.VIDEO, Constants.contentMediaType.HTML];
        availableTypes.splice(availableTypes.indexOf(contentTypes), 1);
        contentTypes += `,${_.shuffle(availableTypes)[0]}`;
        const classificationIds: string =
            currentLearningMap && currentLearningMap.classificationIds ? currentLearningMap.classificationIds.join(',') : '';

        dispatch(buildingContentRecommendations({ categoryIds, contentTypes, classificationIds } as BotRecommendationRequest));
    }

    static sendConsumedLearningMapNotification(dispatch: Dispatch, currentLearningMap: LearningMap, currentContentWorkload: number) {
        if (currentLearningMap) {
            const consumedPercentage = getPercentage(currentLearningMap.minutes, currentLearningMap.consumedMinutes);
            const currentConsumedPercentage = getPercentage(currentLearningMap.minutes, currentLearningMap.consumedMinutes + currentContentWorkload);
            if (consumedPercentage < 80 && currentConsumedPercentage >= 80 && currentConsumedPercentage < 100) {
                dispatch(sendNewEventRequest(Constants.chatbotEvents.CHATBOT_LEARNING_MAP_80));
            } else if (consumedPercentage < 100 && currentConsumedPercentage >= 100) {
                analyticsService.logEvent(FlowEvents.LEARNING_MAP_COMPLETED);
                dispatch(sendNewEventRequest(Constants.chatbotEvents.CHATBOT_LEARNING_MAP_COMPLETED));
            }
        }
    }
}
